import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=553c587c"
import script from "./Switch.vue?vue&type=script&setup=true&lang=js"
export * from "./Switch.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('553c587c')) {
      api.createRecord('553c587c', component.options)
    } else {
      api.reload('553c587c', component.options)
    }
    module.hot.accept("./Switch.vue?vue&type=template&id=553c587c", function () {
      api.rerender('553c587c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/forms/Switch.vue"
export default component.exports